import { WidgetControlType } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Preset for testing absolute value functions.
 * Focus: V-shape with vertex and roots.
 */
export const ABSOLUTE_PRESET: GraphpadWidgetConfig = {
  id: 'absolute',
  type: 'graphpad',
  params: {
    f: {
      type: 'absolute',
      params: { a: 1, h: -2, k: -4 },
    },
    'f-translate': {
      type: 'handle',
      params: { of: 'f', behavior: 'translate' },
    },
    'f-roots': {
      type: 'roots',
      params: { of: 'f' },
    },
    'y-intercept': {
      type: 'yIntercept',
      params: { of: 'f' },
    },
    'axis-of-symmetry': {
      type: 'axisOfSymmetry',
      params: { of: 'f' },
    },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -8, xEnd: 4, yStart: -6, yEnd: 4 },
      grid: { type: 'lines', visible: true },
      axes: true,
    },
    elements: {
      'f-roots': {
        point: { label: { contentVariant: 'coord', position: 'top' } },
      },
      'y-intercept': {
        point: { label: { contentVariant: 'name+coord', position: 'topLeft' } },
      },
      'axis-of-symmetry': {
        line: { label: { contentVariant: 'name', position: 'top' } },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-a',
        type: WidgetControlType.Slider,
        label: 'a (scale)',
        param: 'f.a',
        range: [-3, 3, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'orange',
      },
      {
        id: 'slider-h',
        type: WidgetControlType.Slider,
        label: 'h (x-shift)',
        param: 'f.h',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'green',
      },
      {
        id: 'slider-k',
        type: WidgetControlType.Slider,
        label: 'k (y-shift)',
        param: 'f.k',
        range: [-5, 5, 0.5],
        defaultValue: -2,
        editable: true,
        color: 'amber',
      },
    ],
  },
};
